<template>
  <div class="orderechange-list">
    <br/>
    <div :style="{ 'margin-bottom': toolbarMarginBottom }">
      <Toolbar :handle-add="() => addHandlerSub('OrderAction',parentOrder)" v-if="userHasAccess('action_edit')">
        <template #left>
          <h1><v-icon large>mdi-message-badge-outline</v-icon>{{$t('order.echanges')}}</h1>
        </template>
      </Toolbar>
    </div>

    <v-container grid-list-xl fluid  >
      <v-layout row wrap >

        <v-flex lg12 >
          <v-data-table
              v-model="selected"
              dense
              :headers="headers"
              :items="itemsEchange" 
              :loading="isLoading"
              :loading-text="$t('global.loading')"
              :options.sync="options"
              class="elevation-1"
              item-key="@id"
              @click:row="showHandler"
              @contextmenu:row="showHandlerExt"
              @update:options="onUpdateOptions"
          >
            <template  slot="item.date" slot-scope="{ item }">
              <pre class="truncate" >{{ formatDateTime(item['date'], 'long') }}</pre>
            </template>

            <template slot="item.type" slot-scope="{ item }">
              <v-chip  class="ma-1 font-weight-bold"  label  color="secondary">{{ item['type'].name }}</v-chip>
            </template>

            <template  slot="item.user" slot-scope="{ item }">
              <pre class="truncate">{{item.createdBy.login}}</pre>
            </template>

            <template  slot="item.comment" slot-scope="{ item }">
              <pre class="truncate">{{item.comment}}</pre>
            </template>

            <template slot="item.file" slot-scope="{ item }">
              <v-btn
                  v-if="item['file']"
                  color="secondary"
                  fab
                  small
                  @click="downloadFileList(item['id'],item['@entity'],item['file'].filePath)"
              >
                <v-icon dark >mdi-download </v-icon>
              </v-btn>
            </template>
          
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>

  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import FileMixin from "../../mixins/FileMixin";
import Toolbar from "../Toolbar.vue";
import AccessMixin from "../../mixins/AccessMixin";

const servicePrefix = 'OrderEchange';
export default {
name: 'OrderActionList',
servicePrefix,
components: {
  Toolbar,
},
props : ['parentOrder'],
data() {
  return {
    headers: [
      { text: this.$t('global.date'), value: 'date' , width: 150},
      { text: this.$t('orderaction.titre'), value: 'titre', width: 100},
      { text: this.$t('orderaction.type'), value: 'type', sortable: false, width: 20},
      { text: this.$t('orderaction.user'), value: 'user', sortable: false,width: 100},
      { text: this.$t('orderaction.comment'), value: 'comment', sortable: false},
      { text: this.$t('orderaction.file'), value: 'file', sortable: false, width: 100},
    ],
    selected: [],
    footer: {
      'itemsPerPageText': "",
    },
    options: {sortBy : ['date'], sortDesc : [true]},
    parentAdd: {
      '@id' : this.$route.params.id,
    },
    filters: {
      'orderRef' : this.$route.params.id,
    },
    toolbarMarginBottom: '20px',
  };
  
},
mixins: [ListMixin, FileMixin, AccessMixin],
computed: {
  ...mapFields('orderaction',{
    deletedItem: 'deleted',
    error: 'error',
    isLoading: 'isLoading',
    resetList: 'resetList',
    totalItems: 'totalItems',
    view: 'view'
  }),

  ...mapGetters('orderaction', {
    items: 'list'
  }),
  
    itemsEchange() {
    return this.items.filter(item => {
      if (item.comment) {
        return true; 
      } else {
        return false; 
      }
    });
  },
},
methods: {
  ...mapActions('orderaction', {
    getPage: 'fetchAll',
  }),
  showHandler(item) {
    this.$router.push({
      name: `OrderActionShow`,
      params: { id: item['@id'] }
    });
  },

}
}
</script>
<style>
.truncate {
max-width: auto;
word-wrap: break-word;
white-space: pre-wrap;
overflow: hidden;
display: block;
}

</style>
